import { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';
import { ZipCodePatternMaskProps } from '../FormZipCodeField.types';

export const ZipCodePatternMask = forwardRef<HTMLInputElement, ZipCodePatternMaskProps>(({ onChange, ...props }, ref) => {

    /**
     * This handles the callback to our input element onChange.
     * We have to construct a psuedo change event manually to pass it to the
     * input element onChange.
     */
    const handleAccept = (value: string, masked: any) => {
        if (onChange) {
            const event = {
                ...masked.el,
                target: {
                    ...masked.el,
                    value: value,
                    selectionEnd: masked._selection.end,
                },
            };

            onChange(event as React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>);
        }
    };

    return (
        <IMaskInput
            {...props}
            mask={'#####'}
            definitions={{
                '#': /[\d]/,
            }}
            inputRef={ref}
            onAccept={handleAccept}
        />
    );
});